import { useQuery } from "urql";

import {
  GetIdpFdsDocument,
  IdpFdDocumentsFilter,
  IdpFdDocumentsOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export const useIDPResults = ({
  filter,
  orderBy,
  pause,
  page,
}: ApiHookProps<IdpFdDocumentsFilter, IdpFdDocumentsOrderBy>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({
    query: GetIdpFdsDocument,
    variables,
    pause,
  });
};
